module.exports = __webpack_public_path__ + "static/img/auction-list-icon.5bbabf10.png";